// extracted by mini-css-extract-plugin
export default {"container":"OneColTwoCol-module__container__ZyW5G","col":"OneColTwoCol-module__col__V4pVJ","right":"OneColTwoCol-module__right__Zex03"};